import React from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import { useParkingQueue } from '../../hooks/parkingQueue';
import { SpotEntryPrefill } from '../../Helpers/parkingQueueUtils';
import { ParkingQueueEntryInput } from '../../types/parkingQueue';
import ParkingQueueEntryModal from './ParkingQueueEntryModal';

interface Props {
    onHide: () => void;
    onSubmit: (input: ParkingQueueEntryInput) => Promise<void>;
    prefill: SpotEntryPrefill;
    submitting: boolean;
    error: string | null;
}

/**
 * Ny köplats from a spot's Kö section. Mounted only while open, so the whole
 * queue (entries, leases, every building's areas) the form needs is read then.
 */
const AddToQueueModal: React.FC<Props> = ({ onHide, onSubmit, prefill, submitting, error }) => {
    const queue = useParkingQueue();
    if (queue.loading || queue.error) {
        return (
            <Modal show onHide={onHide} size="lg">
                <Modal.Header closeButton><Modal.Title>Ny köplats</Modal.Title></Modal.Header>
                <Modal.Body>
                    {queue.error
                        ? <Alert variant="danger" className="mb-0">{queue.error}</Alert>
                        : <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>}
                </Modal.Body>
                <Modal.Footer><Button variant="secondary" onClick={onHide}>Avbryt</Button></Modal.Footer>
            </Modal>
        );
    }
    return (
        <ParkingQueueEntryModal show onHide={onHide} onSubmit={onSubmit} prefill={prefill} queue={queue}
            submitting={submitting} error={error} />
    );
};

export default AddToQueueModal;
